module.exports = __webpack_public_path__ + "media/images/Brandfolder_logo-d42659ac.png";